import { render, staticRenderFns } from "./CytomineTask.vue?vue&type=template&id=c67b451c&scoped=true"
import script from "./CytomineTask.vue?vue&type=script&lang=js"
export * from "./CytomineTask.vue?vue&type=script&lang=js"
import style0 from "./CytomineTask.vue?vue&type=style&index=0&id=c67b451c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67b451c",
  null
  
)

export default component.exports